import { Request } from '../request';
import type {
    TTextVisitRefundDetailResponse,
    TUpdateRefundNoteRequest,
    TApproveRefundRequest,
} from 'types/textVisitRefund';

// 获取退款详情
export const getTextVisitRefundDetail = (refundId: number) =>
    Request.get<TTextVisitRefundDetailResponse>({
        url: `/admin-server/text/visit/requestRefund/detail/${refundId}`,
    });

// 更新退款备注
export const updateTextVisitRefundNote = (data: TUpdateRefundNoteRequest) =>
    Request.post<TUpdateRefundNoteRequest>({
        url: '/admin-server/text/visit/requestRefund/note/update',
        params: data,
    });

// 退款审批
export const approveTextVisitRefund = (data: TApproveRefundRequest) =>
    Request.post<TApproveRefundRequest>({
        url: '/admin-server/text/visit/requestRefund/approve',
        params: data,
    });
